import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2, Check, KeyRound, PawPrint, AlertCircle } from "lucide-react";
import { checkInvite, setupPassword } from "../lib/adminP1Api";

export default function SetupPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [erro, setErro] = useState(null);
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    checkInvite(token).then(setInfo).catch((e) => {
      setErro(e?.response?.data?.detail || "Convite inválido ou expirado.");
    });
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) { setErro("Password tem de ter ≥ 8 caracteres."); return; }
    if (pwd !== pwd2) { setErro("As passwords não coincidem."); return; }
    setSaving(true);
    setErro(null);
    try {
      await setupPassword(token, pwd);
      setDone(true);
      setTimeout(() => navigate("/admin/login"), 2200);
    } catch (err) {
      setErro(err?.response?.data?.detail || "Erro ao definir password.");
    } finally { setSaving(false); }
  };

  const inputCls = "w-full rounded-xl bg-white border-2 border-[#1E5F6E]/10 px-4 py-3 text-sm focus:border-[#1E5F6E] focus:outline-none";

  return (
    <div className="min-h-screen grid place-items-center px-5 py-12"
      style={{ background: "radial-gradient(1000px 500px at 80% -10%, rgba(30,95,110,0.15), transparent 60%), linear-gradient(180deg, #FAF7F2 0%, #E9EFF0 100%)" }}
      data-testid="setup-password-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <span className="grid h-11 w-11 place-items-center rounded-xl bg-[#1E5F6E] text-[#FAF7F2] shadow-glow">
            <PawPrint className="h-6 w-6" strokeWidth={2.4} />
          </span>
          <span className="font-display text-2xl font-extrabold">Vet Clinic</span>
        </div>
        <div className="rounded-3xl bg-white border border-[#1E5F6E]/10 p-7 md:p-9 shadow-soft">
          {done ? (
            <div className="text-center py-6" data-testid="setup-success">
              <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-emerald-100 text-emerald-700 mb-4">
                <Check className="h-7 w-7" strokeWidth={3} />
              </div>
              <h2 className="font-display text-xl font-bold">Conta ativada.</h2>
              <p className="text-sm text-[#5A5A5A] mt-1">A redirecionar para o login...</p>
            </div>
          ) : erro && !info ? (
            <div className="text-center py-4" data-testid="invite-erro">
              <AlertCircle className="h-8 w-8 text-rose-600 mx-auto mb-2" />
              <h2 className="font-display text-xl font-bold">Convite inválido</h2>
              <p className="text-sm text-[#5A5A5A] mt-1">{erro}</p>
              <Link to="/admin/login" className="mt-4 inline-block text-sm font-bold text-[#1E5F6E] underline">Ir para login</Link>
            </div>
          ) : !info ? (
            <div className="text-center py-6 text-[#5A5A5A]"><Loader2 className="h-5 w-5 animate-spin inline" /> A validar convite...</div>
          ) : (
            <>
              <h1 className="font-display text-xl font-bold">Defina a sua password</h1>
              <p className="text-sm text-[#5A5A5A] mt-1">Bem-vindo, <strong className="text-[#1A1A1A]">{info.nome}</strong>. Crie uma password segura para a sua conta <strong>{info.email}</strong>.</p>
              <form onSubmit={submit} className="mt-5 space-y-3" data-testid="setup-form">
                <label className="block"><span className="text-sm font-semibold">Password</span>
                  <input type="password" required minLength={8} data-testid="setup-pwd" value={pwd} onChange={(e) => setPwd(e.target.value)} className={inputCls + " mt-1"} /></label>
                <label className="block"><span className="text-sm font-semibold">Confirmar password</span>
                  <input type="password" required minLength={8} data-testid="setup-pwd2" value={pwd2} onChange={(e) => setPwd2(e.target.value)} className={inputCls + " mt-1"} /></label>
                {erro && <p className="text-sm text-rose-600" data-testid="setup-erro">{erro}</p>}
                <button type="submit" disabled={saving} data-testid="setup-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#1E5F6E] text-white px-6 py-3 text-sm font-bold hover:bg-[#174E5B] disabled:opacity-40">
                  {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}
                  Ativar conta
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
